import { useCallback, useRef } from 'react';
import { ConnectableObservable, Observable, Subject, Subscription } from 'rxjs';
import { initializeViewer, ParametricViewer } from './index';
import { multicast } from 'rxjs/operators';

type RefCallback = (ref: HTMLElement | null) => void;
type ResultType = [Observable<ParametricViewer>, RefCallback];

export function useShapeDiver(): ResultType {
  const containerRef = useRef<HTMLElement>();
  const subscriptionRef = useRef<Subscription>();

  const viewer$Ref = useRef<Subject<ParametricViewer>>(new Subject());

  const refCallback = useCallback((container: HTMLElement | null) => {
    const subscription = subscriptionRef.current;
    if (subscription) {
      subscription.unsubscribe();
      subscriptionRef.current = undefined;
    }

    if (!container) return;

    containerRef.current = container;
    const connectable = initializeViewer(PW.config.ticketId, container).pipe(
      multicast(viewer$Ref.current)
    ) as ConnectableObservable<ParametricViewer>;

    subscriptionRef.current = connectable.connect();
  }, []);

  return [viewer$Ref.current, refCallback];
}
